import { styled } from 'styled-components';
import { flexMixin } from '@styles/mixins';
import { colors } from '@styles';

export const WrapSelect = styled.div`
    ${flexMixin('column', 'flex-start', 'flex-start')}
    width: 100%;
    margin: 12px 0 20px 0;
    && span {
        font-size: 12px;
        color: ${colors.grey};
    }
`;
